import { useState } from "react";
import { Avatar } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

import { formatImgUrl } from "../../../../../../../utils/cardFormating";

import { EditEntityProfileData } from "../../../../../types/editEntityProfile-type";

const EntityLogoField = () => {
  const { control, setValue } = useFormContext<EditEntityProfileData>();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  return (
    <Controller
      name="mediaUrl"
      control={control}
      render={({ field: { value, onChange } }) => (
        <>
          <Avatar
            src={selectedFile ? URL.createObjectURL(selectedFile) : formatImgUrl(value)}
            sx={{ width: 110, height: 110, cursor: "pointer", mx: "auto" }}
            onClick={() => document.getElementById("profile-image-input")?.click()}
          />
          <input
            id="profile-image-input"
            type="file"
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) {
                setSelectedFile(file);
                onChange(file.name);
                setValue("mediaFile", file);
              }
            }}
            style={{ display: "none" }}
          />
        </>
      )}
    />
  );
};

export default EntityLogoField;
